import { render, staticRenderFns } from "./PubgMobileAccount.vue?vue&type=template&id=52d179d0&lang=pug"
import script from "./PubgMobileAccount.vue?vue&type=script&lang=js"
export * from "./PubgMobileAccount.vue?vue&type=script&lang=js"
import style0 from "./PubgMobileAccount.vue?vue&type=style&index=0&id=52d179d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports